<template>
  <div>
    <p class="title">未成年人家长监护体系</p>
    <p class="little-t">帮助家长防范未成年人沉迷网游</p>
    <p class="content" v-html="content"></p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      content:
        "“网络游戏未成年人家长监护工程”是一项由完美时空、腾讯、盛大游戏、网易、搜狐畅游、巨人网络六家网络游戏企业共同发起并参与实施，由中华人民共和国文化部指导，旨在加强家长对未成年人参与网络游戏的监护，引导未成年人健康、绿色参与网络游戏，和谐家庭关系的社会性公益行动。它提供了一种切实可行的方法，一种家长实施监控的管道，使家长纠正部分未成年子女沉迷游戏的行为成为可能。\
        <br><br>该项社会公益行动充分反映了中国网络游戏行业高度的社会责任感，对未成年玩家合法权益的关注及对用实际行动营造和谐社会的愿望。<br><br>\
        <span style='color:#ef653d;font-size:16px'>未成年人健康参与网络游戏提示</span><br>\
        随着网络在青少年中的普及，未成年人接触网络游戏已经成为普遍现象。为保护未成年人健康参与游戏，在政府进一步加强行业管理的前提下，家长也应当加强监护引导。为此，我们为未成年人参与网络游戏提供以下意见：<br><br>\
        1.主动控制游戏时间。游戏只是学习、生活的调剂，要积极参与线下的各类活动，并让父母了解自己在网络游戏中的行为和体验。<br>\
        2.不参与可能耗费较多时间的游戏设置。不玩大型角色扮演类游戏，不玩有PK类设置的游戏。在校学生每周玩游戏不超过2小时，每月在游戏中的花费不超过10元。<br>\
        3.不要将游戏当作精神寄托。尤其在现实生活中遇到压力和挫折时，应多与家人朋友交流倾诉，不要只依靠游戏来缓解压力。<br>\
        4.养成积极健康的游戏心态。克服攀比、炫耀、仇恨和报复等心理，避免形成欺凌弱小、抢劫他人等不良网络行为习惯。<br>\
        5.注意保护个人信息。包括个人家庭、朋友身份信息，家庭、学校、单位地址，电话号码等，防范网络陷阱和网络犯罪。"
    };
  },
  mounted: function() {},
  methods: {}
};
</script>
<style scoped>
.title {
  color: #ef653d;
  width: 900px;
  font-size: 26px;
  text-align: center;
  margin:50px auto 0;
  font-weight: 600
}
.redText{
    color: #ef653d;
    font-size: 16px
}
.little-t{
  color: #ef653d;
  width: 900px;
  font-size: 18px;
  text-align: center;
  margin:0 auto;
  padding: 5px 0 30px;
  font-weight: 600
}
.content {
  width: 900px;
  margin: 0 auto;
  padding: 20px 0 150px;
  font-size: 15px;
  color: #5d5d5d;
  text-align: left;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/components/engineering.vue